import { DURATION } from './config';

let currentZoneIndex = 1;

let canScroll = true;

function blockScroll() {
  canScroll = false;
  setTimeout(() => {
    canScroll = true;
  }, DURATION / 2);
}

export function checkSliderZone(index, slider) {
  const currentSlider = slider?.querySelector('.fund');
  if (!currentSlider) return;
  activateZone(index);
}

function activateZone(index) {
  currentZoneIndex = index;

  document.querySelectorAll('.card-zones').forEach(el => {
    el.classList.remove('is-active');
  });
  document.querySelectorAll('.zones__tl').forEach(el => {
    el.classList.remove('is-active', 'is-visible');
  });
  document.querySelectorAll('.zones__region').forEach(el => {
    el.classList.remove('is-active');
  });

  document
    .querySelectorAll(`.card-zones[data-index="${index}"]`)
    .forEach(el => {
      el.classList.add('is-active');
    });
  document.querySelectorAll(`.zones__tl[data-index="${index}"]`).forEach(el => {
    el.classList.add('is-active');
    setTimeout(() => {
      el.classList.add('is-visible');
    }, 100);
  });
  document
    .querySelectorAll(`.zones__region[data-index="${index}"]`)
    .forEach(el => {
      el.classList.add('is-active');
    });

  positionCardZones();
}

function positionCardZones() {
  const svg = document.querySelector('#ukraineZones');
  if (!svg) return;

  const mapBox = document.querySelector('.zones-map__box');
  const regions = document.querySelectorAll('.zones__region');

  regions.forEach(region => {
    const index = region.dataset.index;

    const card = document.querySelector(`.card-zones[data-index="${index}"]`);
    if (!card) return;

    const circle = region.querySelector('circle');
    if (!circle) return;

    const cx = +circle.getAttribute('cx');
    const cy = +circle.getAttribute('cy');

    const pt = svg.createSVGPoint();
    pt.x = cx;
    pt.y = cy;
    const screenCTM = circle.getScreenCTM();
    const { x, y } = pt.matrixTransform(screenCTM);

    const mapRect = mapBox.getBoundingClientRect();

    card.style.top = `${y - mapRect.top}px`;
    card.style.left = `${x - mapRect.left}px`;
  });
}

function initZoneArrows() {
  const zonesMap = document.querySelector('.zones-map');
  if (!zonesMap) return;

  const prevBtn = zonesMap.querySelector('.arrows__prev');
  const nextBtn = zonesMap.querySelector('.arrows__next');
  const zonesCount = document.querySelectorAll('.zones__region').length;

  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => {
      if (!canScroll) return;

      currentZoneIndex -= 1;
      if (currentZoneIndex < 1) currentZoneIndex = zonesCount;
      activateZone(currentZoneIndex);

      blockScroll();
    });

    nextBtn.addEventListener('click', () => {
      if (!canScroll) return;

      currentZoneIndex += 1;
      if (currentZoneIndex > zonesCount) currentZoneIndex = 1;
      activateZone(currentZoneIndex);

      blockScroll();
    });
  }
}

// function createZonePoints() {
//   const svg = document.querySelector('#ukraineZones');
//   if (!svg) return;

//   const mapBox = document.querySelector('.zones-map__box');
//   const regions = document.querySelectorAll('.zones__region');

//   regions.forEach(region => {
//     const index = region.dataset.index;

//     // шукаємо вже існуючу точку
//     let span = mapBox.querySelector(`.zones__point[data-index="${index}"]`);
//     if (!span) {
//       span = document.createElement('span');
//       span.classList.add('zones__point');
//       if (+index === 1) span.classList.add('is-active');
//       span.dataset.index = index;
//       mapBox.appendChild(span);
//     }

//     const circle = region.querySelector('circle');
//     if (!circle) return;

//     const cx = +circle.getAttribute('cx');
//     const cy = +circle.getAttribute('cy');

//     const pt = svg.createSVGPoint();
//     pt.x = cx;
//     pt.y = cy;
//     const screenCTM = circle.getScreenCTM();
//     const { x, y } = pt.matrixTransform(screenCTM);

//     const mapRect = mapBox.getBoundingClientRect();

//     span.style.top = `${y - mapRect.top}px`;
//     span.style.left = `${x - mapRect.left}px`;
//   });
// }

window.addEventListener('resize', () => {
  positionCardZones();
});

window.addEventListener('DOMContentLoaded', () => {
  activateZone(1);
  initZoneArrows();
  positionCardZones();
});
